import React, { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink, Link, useHistory } from "react-router-dom";
import { Button } from "flowbite-react";

import useAccount from "hooks/useAccount";
import UserNavMenu from "components/Header/components/UserNavMenu";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const CreationHeader = ({ height, onClickedLogin, disableNav }) => {
  const user = useSelector((state) => state.auth.user);
  const { userIsLoggedIn, logout } = useAccount();
  const isLoggedIn = userIsLoggedIn(user);
  const history = useHistory();
  const booking = useSelector((state) => state.booking);
  const location = useLocation();
  const [indexOfRoute, setIndexOfRoute] = useState(null);

  const routes = [
    "/where",
    "/when",
    "/what",
    "/anything",
    "/budget",
    "/confirm",
    "/charge",
  ];

  useEffect(() => {
    let index = routes.indexOf(location.pathname);
    if (index > 5) {
      index = 5;
    }
    setIndexOfRoute(index);
  }, [location]);

  const LinkTo = ({ title, to }) => {
    let indexOfTo = routes.indexOf(to);
    return (
      <div className="flex flex-col items-center ">
        <div className="flex w-full justify-center items-center my-1">
          <div
            className={`rounded-full bg-[var(--orange)] w-4 h-4 ${
              indexOfTo > indexOfRoute ? "opacity-25" : "opacity-100"
            } transition-all duration-500 transition-delay-500`}
          ></div>
        </div>
        <NavLink
          to={`${to}`}
          className={`lowercase font-bold`}
          onClick={(e) => {
            if (disableNav) e.preventDefault();
          }}
        >
          <span className="hidden md:inline">{title}</span>
        </NavLink>
      </div>
    );
  };

  return (
    <header className="w-full bg-white sticky top-0 left-0 z-[100]">
      <div className={`container mx-auto h-[${height}px] w-full z-10`}>
        <div className="flex items-center">
          <div className="w-2/12 flex items-center">
            <Link
              to={isLoggedIn ? `/` : null}
              style={{
                cursor: isLoggedIn ? "pointer" : "default",
              }}
            >
              <img
                className="h-[50px] md:h-[60px] ml-2"
                src="/webclip.png"
                alt=""
                style={{
                  width: "auto",
                }}
              />
            </Link>
          </div>

          <div className="w-8/12 text-center relative">
            <div className="grid grid-cols-6 gap-4 items-start justify-center relative">
              <Fragment>
                {booking.status !== "confirmed" && (
                  <Fragment>
                    <LinkTo to={`/where`} title="Where?" />
                    <LinkTo to={`/when`} title="When?" />
                    <LinkTo to={`/what`} title="What?" />
                    <LinkTo to={`/anything`} title="Anything Else?" />
                    <LinkTo to={`/budget`} title="Budget" />
                    <LinkTo to={`/confirm`} title="Confirm" />
                  </Fragment>
                )}
              </Fragment>
            </div>
            {booking.status !== "confirmed" && (
              <div
                className="h-[2px]  absolute w-[50%] md:w-[85%]"
                style={{ top: "11px", left: "7.5%" }}
              >
                <div
                  className="w-full h-full transion-all duration-500"
                  style={{
                    background: "rgb(225,115,56)",
                    linearGradient:
                      "(90deg, rgba(225,115,56,1) 50%, rgba(225,115,56,0) 100%)",
                    width: `calc(${(indexOfRoute * 100) / 6}% + ${
                      20 * (indexOfRoute + 1)
                    }px)`,
                  }}
                ></div>
              </div>
            )}
          </div>

          <div className="w-2/12 text-right pt-[19px] md:pt-[10px]">
            <div className="absolute top-0 right-0 pt-2 md:p-4">
              <UserNavMenu isLoggedIn={isLoggedIn} />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default CreationHeader;
